import React, { Component } from 'react'
import './style.css'

class Messages extends Component {
  render() {
    return (
      <div className="home-container">
        <h1>Settings</h1> 
      </div>
    );
  }
}

export default Messages;



// WEBPACK FOOTER //
// ./src/views/Settings/index.js